@if (!!account) {
  <div
    class="type type--{{account | accountType}}"
    translate="dashboard.account-group.title.{{account | accountType}}"
  ></div>
}
